<template>
  <div class="form-edit">
    <transition name="fade" mode="out-in">
      <div class="form-edit__input" v-if="edit">
        <icon-loading class="form-edit__input__loading" v-if="isLoading" />
        <input
          v-letter="isLetter"
          v-numeric="isNumeric"
          :class="classObject"
          type="text"
          :placeholder="title"
          :name="title"
          autocomplete="off"
          @keyup="changed"
          v-model.trim="val"
        />

        <!-- <fancy-info :text="errorText" /> -->
        <div
          class="form-edit__input__save"
          :class="{ '-loading': isLoading }"
          @click="save()"
        >
          <icon-check />
        </div>
      </div>
      <span
        class="form-edit__label"
        :title="title"
        v-else
        @click="makeEditable()"
        >{{ value }}</span
      >
    </transition>
  </div>
</template>

<script>
import { letter, numeric } from "@/directives/";
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    id: {
      type: Number,
      default: 0,
    },
    isLetter: {
      type: Boolean,
      default: false,
    },
    isNumeric: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: this.value,
      edit: this.isEdit,
      isLoading: false,
    };
  },
  computed: {
    classObject: function () {
      let list = {
        "-error": this.isError,
        "-loading": this.isLoading,
      };

      return list;
    },
  },
  watch: {
    value: function (val) {
      this.val = val;
    },
  },
  directives: { letter, numeric },
  methods: {
    changed: function (e) {
      // this.$emit('input', e.target.value)

      return e.target.value;
    },
    makeEditable: function () {
      let vm = this;

      this.edit = true;

      vm.$emit("action", vm.id, vm.title);
    },
    save: function () {
      let vm = this;

      vm.edit = false;

      vm.$emit("action", vm.id, vm.title, vm.val);

      // if (vm.isLoading) return;

      // vm.isLoading = true;

      // setTimeout(() => {
      //   vm.isLoading = false;
      //   vm.edit = false;
      // }, 3000);
    },
  },
};
</script>